export default __webpack_public_path__ + "static/media/api-ai.9b351a7b.svg";